import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isSRPFilterLoading: false,
    isSRPSortLoading: false,
    isStateLoading: false,
    srpFilterInitData: [],
    sortFilterConfig: {},
    states: [],
    srpDisabledFilter: [],
  };

  export const srpFilterSlice = createSlice({
    name: "srpFilter",
    initialState,
    reducers: {
        fetchSRPFilterInitialLoad: (state) => {
            state.isSRPFilterLoading = true;
            state.isSRPSortLoading = true;
        },
        fetchSRPFilterInitialLoadSuccess: (state, action) => {
            state.isSRPFilterLoading = false;
            state.srpFilterInitData = action.payload;
        },
        fetchSRPFilterInitialLoadFailure: (state, action) => {
            state.isSRPFilterLoading = false;
            state.srpFilterInitData = action.payload;
        },
        fetchSRPSortInitialLoadSuccess: (state, action) => {
            state.isSRPSortLoading = false;
            state.sortFilterConfig = action.payload;
        },
        fetchSRPSortInitialLoadFailure: (state, action) => {
            state.isSRPFilterLoading = false;
            state.sortFilterConfig = action.payload;
        },
        fetchStateInitialLoad: (state) => {
            state.isStateLoading = true;
        },
        fetchStateInitialLoadSuccess: (state, action) => {
            state.isStateLoading = false;
            state.states = action.payload;
        },
        fetchStateInitialLoadFailure: (state, action) => {
            state.isSRPFilterLoading = false;
            state.states = action.payload;
        },
        fetchDisabledFilterSuccess: (state, action) => {
            state.srpDisabledFilter = action.payload;
        },
        fetchDisabledFilterFailure: (state, action) => {
            state.srpDisabledFilter = action.payload;
        },
    },
});


export const {
    fetchSRPFilterInitialLoad,
    fetchSRPFilterInitialLoadSuccess,
    fetchSRPFilterInitialLoadFailure,
    fetchSRPSortInitialLoadSuccess,
    fetchSRPSortInitialLoadFailure,
    fetchStateInitialLoad,
    fetchStateInitialLoadSuccess,
    fetchStateInitialLoadFailure,
    fetchDisabledFilterSuccess,
    fetchDisabledFilterFailure
} = srpFilterSlice.actions;
export const srpFilterData = (state) => (state.srpFilter)
export default srpFilterSlice.reducer;
